import React, { useState, useEffect, useRef } from 'react';
import * as msal from "@azure/msal-browser";
import axios from 'axios'
import './App.css';
import { CERBOSURL, MUI_KEY } from './config';
//import { LicenseInfo } from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license';
import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import Navbar, { SUPPORT_BUTTON_RIGHT } from './container/NavBar/NavBar';
import GeneralSidebar from './container/GeneralSidebar/GeneralSidebar';
import Landing from './container/Landing/Landing';
import EmailLanding from './container/Landing/emailLanding';
import MobileAppDownload from './container/Landing/MobileAppDownload';
import moment from 'moment';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { SEGMENTAPIKEY, env, APIURL, CLIENT_ID, MSTENANT, SCOPE } from './config';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate  } from '@azure/msal-react';
import CircularProgress from '@mui/material/CircularProgress';
import UserSelectionDialog from './components/Auth/UserSelectionDialog';
import { clearAccountPreference, getAccountIdentity, getRememberedAccount, rememberAccount } from './components/Auth/accountPreference';
import { Switch, Route, Redirect } from 'react-router-dom';
import IntakeForm from './container/GeneratedPages/Forms/IntakeForm';
import ClientSurveyForm from './container/GeneratedPages/Forms/ClientSurveyForm';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import ElliQChat from './components/ElliQChat/ElliQChat';
import FieldWorkerAssistant from './components/FieldWorkerAssistant/FieldWorkerAssistant';
import HelpEmailForm from 'src/components/forms/HelpEmailForm/HelpEmailForm';
import {
  Snackbar,
  Alert,
} from "@mui/material";
import html2canvas from 'html2canvas';
import ReactDOM from 'react-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import entities from './resources.json';

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY });
LicenseInfo.setLicenseKey(MUI_KEY);
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Access-Control-Allow-Origin': '*',
  "Access-Control-Allow-Headers": '*',
  "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
  "Access-Control-Max-Age": 10000,
  'Authorization': 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
}

function MainContent(props) {
  const [selectedProgramId, setSelectedProgramId] = useState(() => {
    const stored = window.localStorage.getItem('FW_SELECTED_PROGRAM_ID');
    return stored ? Number(stored) : null;
  });
  
  const [state, setState] = useState({
    activatedFeatures: {},
    isAuth: false,
    user: {},
    isLoading: false,
    cred: {},
    subscription: true,
    signinBtn: true,
    redirectedFromEmail: false,
    modal: false,
    response: null, // Add response to the state
  });

  const programCallerRef = useRef(null);
  programCallerRef.current = state.user?.emp_id;

  const [showHelpForm, setShowHelpForm] = useState(false);
  const [screenshotAttachment, setScreenshotAttachment] = useState(null);
  const [emailStatus, setEmailStatus] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);


  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();


  const handleSupportClick = async () => {
    const canvas = await html2canvas(document.body, {
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
    });
  
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
    if (!blob) return;
  
    const file = new File([blob], 'screenshot.png', { type: 'image/png' });
    const preview = URL.createObjectURL(file);
  
    setScreenshotAttachment({ file, preview, def: true });
    setShowHelpForm(true);
  };

  const handleDefScreenshotDelete = async () => {
    setScreenshotAttachment(null);
  }

  const handleSendEmail = async ({subject, body, attachments}) => {

    let resp = await axios.post(APIURL + '/calendar/help', {
      emp_id: state.user.emp_id,
      emp_name: state.user.emp_name,
      com_id: state.user.comp_id,
      com_name: state.user.company_name,
      emp_sec_email: state.user.sec_email,
      subject,
      body,
      attachments
    })
    if (resp.data.sent) {
      setEmailStatus("success");
      setTimeout(() => {
        setEmailStatus(null);
      }, 6000);
    } else {
      setEmailStatus("failure");
      setTimeout(() => {
        setEmailStatus(null);
      }, 6000);
    }
  }
  

  let resources = entities.resources.filter((res) => res.resource.kind !== "MobileScreens");

  useEffect(() => {
    async function init() {
      const publicPaths = ['/', '/app', '/app/'];

      if (!window.localStorage.getItem('Fw4_access_Token') && !publicPaths.includes(window.location.pathname)) {
        window.location.href = '/';
      }

      if (env === 'prod') {
        window.document.getElementById('cio-tracker').setAttribute('data-site-id', 'b2894d25baad5a8ad3c2');
      } else {
        window.document.getElementById('cio-tracker').setAttribute('data-site-id', '56e083c08b1a5e933c5a');
      }

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('source') === 'email') {
        setState({ ...state, redirectedFromEmail: true });
      }
    }
    init();
  }, []);

  useEffect(() => {
    if (!!window.localStorage.getItem('Fw4_access_Token') && window.location.pathname === "/home") {
      setTimeout(() => {
        window.history.pushState({}, null, '/');
      }, 2000);
    }
  });

  useEffect(() => {
    if (selectedProgramId) {
      window.localStorage.setItem('FW_SELECTED_PROGRAM_ID', String(selectedProgramId));
    } else {
      window.localStorage.removeItem('FW_SELECTED_PROGRAM_ID');
    }
  }, [selectedProgramId]);

  useEffect(() => {
    const interceptorId = axios.interceptors.request.use((config) => {
      const method = String(config.method || 'get').toLowerCase();
      const url = String(config.url || '');
      const isProgramRequest = url.startsWith(`${APIURL}/programs`);
      const skipProgramInjection = isProgramRequest || url.includes('/programs') || url.includes('/auth') || url.includes('/config/settings');

      if (isProgramRequest && programCallerRef.current) {
        config.params = { ...config.params, emp_id: programCallerRef.current };
      }

      if (method === 'get' && selectedProgramId && !skipProgramInjection) {
        config.params = config.params || {};
        if (config.params.program_id === undefined && config.params.programId === undefined) {
          config.params.program_id = selectedProgramId;
        }
      }

      return config;
    });

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, [selectedProgramId]);

  useEffect(() => {
    const checkExistingUser = async() => {
      if (instance) {
        const accounts = instance.getAllAccounts();
        if(accounts.length > 0) {
          await instance.setActiveAccount(accounts[0]);
          console.log(accounts[0]);
          instance.acquireTokenSilent({ scopes: [SCOPE] })
          .then(async(response) => {
            await getUserDetails();
          })
          .catch(err => {
            instance.logoutPopup();
            console.log(err)
          });
        }
      }
    }

    setTimeout(checkExistingUser, 1);

}, [instance]);

  const checkTokenExpiry = async (fromMount = false) => {
    axios.defaults.headers.Authorization = `Bearer ${window.localStorage.getItem('Fw4_access_Token')}`;

    if (!!instance.getAllAccounts().length && moment().isAfter(moment(window.localStorage.getItem('Fw4_access_Token_exp')).add(-1, 'm'))) {
      return await getUserDetails();
    }

    const accounts = instance.getAllAccounts();
    if (!!fromMount && accounts.length > 0 && moment().isBefore(moment(window.localStorage.getItem('Fw4_access_Token_exp')))) {
      await getUserFromDB({ accessToken: window.localStorage.getItem('Fw4_access_Token'), account: { userName: accounts[0].username } });
    } else {
      return true;
    }
  };

  const loginUser = async () => {
    if (state.modal) {
      logoutUser();
      return;
    }
    const accounts = instance.getAllAccounts();
  if (accounts.length === 0) {
    try {
      // Always prompt the user to select an account
      const { account } = await instance.loginPopup({ 
        scopes: ["User.Read"], 
        prompt: "select_account" // <-- This ensures the account selection prompt always appears
      });
      instance.setActiveAccount(account);
      await getUserDetails();
    } catch (err) {
      console.log(err);
    }
  } else {
    instance.setActiveAccount(accounts[0]);
    await getUserDetails();
  }
  };

  const getUserDetails = async () => {
    return instance.acquireTokenSilent({ scopes: [SCOPE] })
      .then(async response => {
        window.localStorage.setItem('Fw4_access_Token', response.accessToken);
        window.localStorage.setItem('Fw4_access_Token_exp', moment(response.expiresOn).format('YYYY-MM-DDTHH:mm:ss'));
        await getUserFromDB(response);
        return true;
      })
      .catch(err => {
        if (state.modal) {
          window.location.href = '/';
          instance.logoutPopup();
        }
        if (!!window.localStorage.getItem('Fw4_access_Token') && Number(moment(window.localStorage.getItem('Fw4_access_Token_exp')).format('YYYYMMDDHHmm')) - Number(moment().format('YYYYMMDDHHmm')) > 0) {
          window.location.href = '/';
        }
        return false;
      });
  };

  const getUserFromDB = async (response) => {
    axios.defaults.headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
      'Authorization': 'Bearer ' + response.accessToken,
      'Accept': 'application/json'
    };

    let user = await axios.get(APIURL + '/auth', { params: { email: response.account.userName ? response.account.userName : response.account.username } });

    if (user.data.code == 2) {
      window.sessionStorage.clear();
      setState({ ...state, isAuth: false, modal: false, isLoading: false, subscription: false, signinBtn: false });
      setTimeout(() => {
        logoutUser();
      }, 10000);
    } else if (user.data.code == 4) {
      window.sessionStorage.clear();
      setState({ ...state, isAuth: false, modal: false, isLoading: false, subscription: true, signinBtn: false });
      alert("Your employee account has been terminated by your company admin.");
      setTimeout(() => {
        logoutUser();
      }, 1000);
    } else if (user.data.code == 1) {
      window.sessionStorage.clear();
      setState({ ...state, isAuth: false, modal: true, isLoading: false, subscription: true, signinBtn: false });
      setTimeout(() => {
        logoutUser();
      }, 5000);
    } else {
      setState(prevState => ({ ...prevState, users: user.data }));
      if (user.data.length > 1) {
        const currentUser = state.isAuth && getAccountIdentity(state.response?.account) === getAccountIdentity(response.account)
          ? user.data.find(candidate => candidate.emp_id === state.user.emp_id && candidate.emp_company_id === state.user.comp_id)
          : null;
        const preferredUser = currentUser || getRememberedAccount(response.account, user.data);
        if (preferredUser) {
          await handleUserSelection(preferredUser, response);
          return;
        }
        setState(prevState => ({
          ...prevState,
          showUserSelectionDialog: true,
          users: user.data,
          response: response
        }));
      } else {
        console.log(user);
        if(user.data.length === 0){
          logoutUser();
        } else {
          handleUserSelection(user.data[0], response);
        }
      }
    }
  };

  const getCerbosPermissions = async (selectedUser, role, settings, resources) => {

    let checkAccess = await axios.post(CERBOSURL + '/check/resources',{
      principal: {
          id: String(selectedUser.emp_id),
          roles: [role],
          attr: {
              states: selectedUser.states.map(s => s.state_id),
              modules: settings?.data.map(f => f.feature_id),
              company_type: settings?.data.find((s) => s.feature_value === 'primaryBusinessType')?.feature_id,
          }
      },
      resources: resources,
    });

    return checkAccess;

  }


  const handleUserSelection = async (selectedUser, response, remember) => {
    console.log(selectedUser, entities)
    let settings = await axios.get(APIURL + '/config/settings', { params: { comp_id: selectedUser.emp_company_id } })

    let features = {};
    let batchSize = 50;

    console.log(resources);

    for (let index = 0; index < resources.length; index += batchSize) {
      let currentBatch = resources.slice(index, Math.min(index + batchSize, resources.length));
      console.log(currentBatch);
      let predefinedRoles = ['fieldworker', 'supportcoordinator', 'manager', 'admin', 'casemanager'];
      let role = predefinedRoles.includes(String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase()) ? String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase() : `${String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase()}_${selectedUser.emp_company_id}`;
      let checkAccess = await getCerbosPermissions(selectedUser, role, settings, currentBatch.map((r) => {
        return {
          resource: {
            ...r.resource,
            id: r.resource.id + String(selectedUser.emp_id),
          },
          actions: r.actions,
        }
      }));
      currentBatch.forEach((resource) => {
        const results = checkAccess.data.results;
        if (Array.isArray(results)) {
          const ele = results.find((ele) => 
            (resource.resource.id + String(selectedUser.emp_id)) === ele.resource.id
          );
          const action = ele?.actions?.[resource.actions[0]];
          features[String(resource.resource.id).split("#")[0]] = action === 'EFFECT_ALLOW';
        } else {
          features[String(resource.resource.id).split("#")[0]] = false;
        }
      })
    }

    if (Object.values(features).every(value => value === false)) {
      for (let index = 0; index < resources.length; index += batchSize) {
        let currentBatch = resources.slice(index, Math.min(index + batchSize, resources.length));
        console.log(currentBatch);
        let predefinedRoles = ['fieldworker', 'supportcoordinator', 'manager', 'admin', 'casemanager'];
        let role = predefinedRoles.includes(String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase()) ? String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase() : `${String(selectedUser.emp_type).replaceAll(" ", "").toLowerCase()}_${selectedUser.emp_company_id}`;
        let checkAccess = await getCerbosPermissions(selectedUser, String(role).trim().endsWith('manager') ? 'manager' : 'fieldworker', settings, currentBatch.map((r) => {
          return {
            resource: {
              ...r.resource,
              id: r.resource.id + String(selectedUser.emp_id),
            },
            actions: r.actions,
          }
        }));
        currentBatch.forEach((resource) => {
          const results = checkAccess.data.results;
          if (Array.isArray(results)) {
            const ele = results.find((ele) => 
              (resource.resource.id + String(selectedUser.emp_id)) === ele.resource.id
            );
            const action = ele?.actions?.[resource.actions[0]];
            features[String(resource.resource.id).split("#")[0]] = action === 'EFFECT_ALLOW';
          } else {
            features[String(resource.resource.id).split("#")[0]] = false;
          }
        })
      }
    }

    console.log(features);

    if (remember === true) rememberAccount(response.account, selectedUser);
    if (remember === false) clearAccountPreference();

    setState(prevState => ({
      ...prevState,
      activatedFeatures: features,
      isAuth: true,
      response,
      modal: false,
      user: {
        ...prevState.user,
        permissions: features,
        isLoading: false,
        emp_id: selectedUser.emp_id,
        emp_name: selectedUser.emp_first_name + ' ' + selectedUser.emp_last_name,
        email: selectedUser.empEmail,
        sec_email: selectedUser.sec_email,
        emp_timezone: selectedUser.emp_timezone || 'US/Eastern',
        comp_id: selectedUser.emp_company_id,
        company_name: selectedUser.com_name,
        company_logo: selectedUser.logo,
        company_type: settings?.data.find((s) => s.feature_value === 'primaryBusinessType')?.feature_id,
        type: selectedUser.emp_type,
        emp_type: selectedUser.emp_type,
        emp_is_internal_support: selectedUser.emp_is_internal_support,
        emp_is_admin: selectedUser.emp_is_admin,
        emp_manager_id: selectedUser.emp_manager_id,
        accessToken: response.accessToken,
        subs: selectedUser.subs,
        states: selectedUser.states,
        comp_settings: settings?.data,
      },
      showUserSelectionDialog: false
    }));

    var sha1 = require('sha1');
    let sessionID = window.localStorage.getItem('Fw4_access_Token');
    var hash = sha1(sessionID);
    var log_data = {
      emp_id: selectedUser.emp_id,
      email: selectedUser.empEmail,
      actionType: selectedUser.loginNum === 1 ? 'First Login' : 'New Login',
      actionSubType: selectedUser.emp_first_name + ' ' + selectedUser.emp_last_name,
      sessionID: hash
    };
    await axios.post(APIURL + "/activity_log", log_data);

    if (selectedUser.emp_id && selectedUser.sec_email && selectedUser.com_name && selectedUser.emp_company_id && selectedUser.emp_first_name && selectedUser.emp_last_name) {
      window._cio.identify({
        id: String(selectedUser.emp_id),
        email: String(selectedUser.sec_email),
        company: String(selectedUser.com_name),
        company_id: String(selectedUser.emp_company_id),
        first_name: String(selectedUser.emp_first_name),
        last_name: String(selectedUser.emp_last_name),
        name: String(selectedUser.emp_first_name) + ' ' + String(selectedUser.emp_last_name)
      });
      console.log("customer io called");
    }
  };
  
  const logoutUser = async () => {
    if (state.user.emp_id) {
      var sha1 = require('sha1');
      let sessionID = window.localStorage.getItem('Fw4_access_Token');
      var hash = sha1(sessionID);
      var log_data = {
        email: state.user.email,
        actionType: 'Logged out',
        actionSubType: state.user.emp_name,
        sessionID: hash
      };
      await axios.post(APIURL + "/activity_log", log_data);
      analytics.track('Signed Out', {
        name: state.user.emp_name,
        email: state.user.sec_email,
        groupId: String(state.user.comp_id),
        groupName: String(state.user.company_name),
      }, {
        userId: String(state.user.emp_id),
        context: {
          GROUP_ID: String(state.user.comp_id),
        },
      });
    }
    setSelectedProgramId(null);
    window.localStorage.clear();
    await instance.logoutPopup();
    window.location.href = '/';
  };

  const handleProgramChange = (programId) => {
    if (programId === '' || programId === null || programId === undefined || programId === 'all') {
      setSelectedProgramId(null);
      return;
    }
    setSelectedProgramId(Number(programId));
  };

  const switchAccount = () => {
    clearAccountPreference();
    window.localStorage.removeItem('FW_SELECTED_PROGRAM_ID');
    window.sessionStorage.clear();
    // Reload to discard all employee/company-specific component state and pending requests.
    window.location.assign('/');
  };

  const updateSubs = async (subId, op) => {
    let newSubs;
    if (op === 'add') {
      newSubs = [...state.user.subs, { feature_id: subId }];
      setState({ ...state, user: { ...state.user, subs: newSubs } });
    } else if (op === 'rem') {
      newSubs = state.user.subs.filter((d) => d.feature_id !== subId);
      setState({ ...state, user: { ...state.user, subs: newSubs } });
    }
  };

  return (
      <div className="App">
        <ToastContainer
          className={'mt-5'}
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className = "app-content-wrapper">
          <AuthenticatedTemplate>
            {state.user.type === undefined && !state.showUserSelectionDialog ? (
              <div style={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
              </div>
            ) : (
              <div className="content" style={{ paddingRight: chatOpen ? '420px' : '0', transition: 'padding-right 0.2s ease' }}>
                {/* Hidden element for third-party tool data extraction */}
                {!!state.user && !!state.isAuth && (
                  <div 
                    id="user-metadata" 
                    className={`
                      state-${state.user.states?.[0]?.state_id || 'unknown'} 
                      business-type-${state.user.comp_settings?.find(s => s.feature_value === 'primaryBusinessType')?.feature_id || 'unknown'} 
                      employee-type-${String(state.user.type || 'unknown').replace(/\s+/g, '-').toLowerCase()}
                    `.trim()}
                    style={{ display: 'none' }}
                    data-state={state.user.states?.[0]?.state_id}
                    data-business-type={state.user.comp_settings?.find(s => s.feature_value === 'primaryBusinessType')?.feature_id}
                    data-employee-type={state.user.type}
                  />
                )}
                {!!state.user && !!state.isAuth && <Navbar login={loginUser} logout={logoutUser} switchAccount={state.users?.length > 1 ? switchAccount : undefined} isAuth={state.isAuth} user={state.user} selectedProgramId={selectedProgramId} onProgramChange={handleProgramChange} />}
                {!!state.user && !!state.isAuth && (
                  <GeneralSidebar
                    isAuth={state.isAuth}
                    updateSubs={updateSubs}
                    checkTokenExpiry={checkTokenExpiry}
                    comp_id={state.user.comp_id}
                    user={{ ...state.user }}
                    activatedFeatures={{...state.activatedFeatures}}
                    selectedProgramId={selectedProgramId}
                  />
                )}
                {state.isAuth && ReactDOM.createPortal(
                  <Tooltip title="Send email to support" placement="bottom">
                    <IconButton
                      onClick={handleSupportClick}
                      style={{
                        position: 'fixed',
                        top: '15px',
                        right: `${SUPPORT_BUTTON_RIGHT}px`,
                        zIndex: 2000,
                        backgroundColor: '#fff',
                      }}
                    >
                      <SupportAgentIcon />
                    </IconButton>
                  </Tooltip>,
                  document.body
                )}

                {
                  <div onFocus={() => console.log("focussed")} onBlur={() => console.log("blurred")}>
                  <HelpEmailForm
                    isOpen={showHelpForm}
                    onClose={() => {
                      setShowHelpForm(false);
                      setScreenshotAttachment(null);
                    }}
                    initialAttachments={screenshotAttachment ? [screenshotAttachment] : []}
                    handleDefScreenshotDelete={handleDefScreenshotDelete}
                    onSend={handleSendEmail}
                  />

                  <Snackbar open={emailStatus === 'success'} autoHideDuration={6000}>
                    <Alert severity="success">Support Email sent successfully</Alert>
                  </Snackbar>
                  <Snackbar open={emailStatus === 'failure'} autoHideDuration={6000}>
                    <Alert severity="error">Error in sending Support Email</Alert>
                  </Snackbar>

                  </div>
                }

                {/* {state.isAuth && <ElliQChat open={chatOpen} onToggle={setChatOpen} />} */}
                {state.isAuth && <FieldWorkerAssistant open={chatOpen} onToggle={setChatOpen} />}

                {state.showUserSelectionDialog && (
                  <UserSelectionDialog
                    users={state.users}
                    onSelect={(selectedUser, remember) => handleUserSelection(selectedUser, state.response, remember)}
                    onClose={async() => {
                      setState(prevState => ({ ...prevState, showUserSelectionDialog: false }))
                      instance.logoutPopup();
                    }}
                  />
                )}
              </div>
            )}
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            {!state.redirectedFromEmail ? <Landing appstate={state} isLoading={state.isLoading} loginUser={loginUser} /> : <EmailLanding appstate={state} isLoading={state.isLoading} loginUser={loginUser} />}
          </UnauthenticatedTemplate>
        </div>
      </div>
  );
};

const App = (props) => {

  useEffect(() => {
    const refreshToken = async () => {
      const account = props.instance.getActiveAccount();
      if (!account) {
        return;
      }
    
      const silentRequest = {
        forceRefresh: true,
        scopes: [SCOPE],
        account: account
      };
    
      try {
        const silentResult = await props.instance.acquireTokenSilent(silentRequest);
        window.localStorage.setItem('Fw4_access_Token', silentResult.accessToken);
      } catch (error) {
        console.error("Failed to acquire token silently:", error);
      }
    };

    // Call refreshToken immediately and then every 15 minutes
    refreshToken();
    const intervalId = setInterval(refreshToken, 10 * 60 * 1000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [props.instance]);  

  return (
    <MsalProvider instance={props.instance}>
      <Switch>
        <Route exact path="/app" component={MobileAppDownload} />
        <Route exact path="/survey/:token" component={ClientSurveyForm} />
        <Route path="/form/:token" component={IntakeForm} />
        <Route path="/" component={MainContent} />
      </Switch>
    </MsalProvider>
  );
};

export default App;
